<template>
    <div>
        <v-dialog persistent v-model="dialog" width="400" content-class="voipDialog">
            <v-card tile>
                <div class="pa-3 pt-1 bg-primary">
                    <div class="d-flex align-center justify-space-between">
                        <div>
                            <v-btn color="white" variant="text" icon="close" @click="closeThis"></v-btn>
                            <v-btn color="white" variant="text" icon="remove" v-if="status !== 'offline'" @click="minimize = true; dialog = false"></v-btn>
                        </div>
                        <div>
                            <p dir="ltr" v-if="status != 'waitForAnswer'" class="text-white" :class="status == 'offline' && 'voipDialog-time'">
                                {{ minute < 10 ? ('0' + minute) : minute }} : {{ second < 10 ? ('0' + second) : second }}
                            </p>
                        </div>
                    </div>
                    <div class="d-flex ga-4 align-center justify-center">
                        <div>
                            <v-img :src="userProfileImg" width="45" height="45" class="rounded-circle voipDialog-img">
                                <div class="voipDialog-img-icon" :style="{backgroundColor: status == 'offline' ? '#ff5252' : '#34c38f'}">
                                    <v-icon :class="status == 'waitForAnswer' && 'voipDialog-img-icon-waitForAnswer'" color="white" size="18">{{ status == 'online' ? 'call' : status == 'waitForAnswer' ? 'call' : 'call_end' }}</v-icon>
                                    <div v-if="status != 'offline'" :class="status == 'online' && 'position-relative voipDialog-img-icon-items'"><span /><span /></div>
                                </div>
                                <span class="voipDialog-img-overlay" v-if="status == 'waitForAnswer'">
                                    <span /><span /><span />
                                </span>
                            </v-img>
                        </div>
                        <p class="text-meta font-weight-medium text-white">{{caller_name}}</p>
                    </div>
                    <v-divider class="opacity-100 mt-7 mb-3" color="white"></v-divider>
                    <div class="d-flex justify-space-between align-center">
                        <div class="d-flex flex-column ga-2">
                            <div>
                                <v-icon color="white" class="me-1" size="20">phone_enabled</v-icon>
                                <p class="d-inline-block text-white text-meta">{{caller_phone}}</p>
                            </div>
                            <div v-if="organization">
                                <v-icon color="white" class="me-1" size="20">apartment</v-icon>
                                <p class="d-inline-block text-white text-meta">{{organization}}</p>
                            </div>
                            <div v-if="customer_level">
                                <v-icon color="white" class="me-1" size="20">layers</v-icon>
                                <p class="d-inline-block text-white text-meta">{{customer_level}}</p>
                            </div>
                        </div>
                        <div class="d-flex flex-column ga-3">
                            <div v-if="type == 'unknow'" >
                                <v-btn
                                    @click="$router.push({path: '/customers/new', query: {mobile: caller_phone}}); minimize = true; dialog = false"
                                    color="#ffffff26"
                                    block
                                    class="text-white"
                                >ایجاد مشتری</v-btn>
                            </div>
                            <div v-else-if="type == 'employee'">
                                <v-icon color="white" size="20">person</v-icon>
                                <p class="d-inline-block text-white text-meta">اعضای سازمان</p>
                            </div>
                            <v-btn
                                v-if="type == 'customer' && $rbac.can('manage customers')"
                                @click="$router.push({path: `/customers/${id.toString()}`}); minimize = true; dialog = false"
                                color="#ffffff26"
                                block
                                class="text-white"
                            >پروفایل مشتری</v-btn>
                            <v-btn
                                v-if="type == 'customer' && $rbac.can('send ticket to customers')"
                                @click="$router.push({path: '/tickets/fromCustomer', query: { customer_id: id } }); minimize = true; dialog = false"
                                color="#ffffff26"
                                block
                                class="text-white"
                            >تیکت از طرف مشتری</v-btn>
                        </div>
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import noUser from '@/assets/img/noUser.png';
export default {
    data() {
        return {
            dialog: false,
            type: 'unknow',
            caller_name: '',
            caller_phone: '',
            id: null,
            organization: '',
            customer_level: '',
            userProfileImg: noUser,
            status: 'waitForAnswer',
            minute: 0,
            second: 0,
            timeInterval: null,
            minimize: false,
        }
    },
    watch: {
        status(){
            if(this.status == 'online'){
                this.minute = 0;
                this.second = 0;
                this.timeInterval = setInterval(() => {
                    if(this.second < 59)
                        this.second += 1;
                    else{
                        this.second = 0
                        this.minute += 1;
                    }
                }, 1000);
            } else
                clearInterval(this.timeInterval);
        },
    },
    methods: {
        make(data) {
            if(!this.dialog && !this.minimize && data.status != 'Ring')
                return;
            if(data.status == 'Ring') {
                this.caller_name = data.caller_name;
                this.caller_phone = data.caller_phone;
                this.status = 'waitForAnswer';
                this.type = data.type;
                this.id = data.id;
                this.userProfileImg = data.profile_picture_name ?? noUser;
                this.organization = data.type == 'customer' && data.organization ? data.organization : '';
                this.customer_level = data.type == 'customer' && data.customer_level ? data.customer_level : '';
                this.dialog = true;
            } else if(this.caller_phone == data.caller_phone) {
                this.status = data.status == 'Answer' ? 'online' : 'offline';
            }
        },
        closeThis() {
            this.dialog = false;
            clearInterval(this.timeInterval);
        }
    },
}
</script>
<style lang="scss">
    .voipDialog{
        top: 50px;
        position: absolute;
        &-img{
            border: 1px solid white;
            position: relative;
            overflow: visible;
            .v-image__image{
                border-radius: 50rem !important;
            }
            &-icon{
                position: absolute;
                inset: auto -12px -12px auto;
                border-radius: 50rem;
                padding: 3px 6px 4px 6px;
                @media only screen and (max-width: 768px){
                    padding: 4px;
                }
                &-waitForAnswer{
                    animation: shakeX alternate 1.3s infinite;
                }
                &-items{
                    & span{
                        position: absolute;
                        border-radius: 50rem;
                        border-width: 1px;
                        border-color: transparent white transparent transparent;
                        border-style: solid;
                        transform: rotate(-45deg);
                        animation: blink alternate 0.5s infinite;
                        &:nth-child(1){
                            inset: -18px 2px auto auto;
                            width: 15px;
                            height: 15px;
                        }
                        &:nth-child(2){
                            inset: -21px -1px auto auto;
                            width: 20px;
                            height: 20px;
                            animation-delay: 0.1s;
                        }
                    }
                }
            }
            @for $i from 1 through 3 {
                &-overlay span:nth-child(#{$i}){
                    position: absolute;
                    inset: -($i * 3px);
                    border: 1px solid #ffffff70;
                    animation: blink alternate 0.6s infinite;
                    animation-delay: $i * 0.15s;
                    z-index: -1;
                    border-radius: 50rem;
                }
            }
        }
        &-time{
            animation: blink 1s alternate-reverse infinite;
        }
    }
    @keyframes blink {
        from { opacity: 0; }
        to { opacity: 1; }
    }
    @keyframes shakeX {
        from { transform: translateX(0px) rotate(0deg) }
        4% { transform: translateX(1px) rotate(8deg) }
        8% { transform: translateX(0px) rotate(0deg) }
        12% { transform: translateX(-1px) rotate(-2deg) }
        16% { transform: translateX(0px) rotate(0deg) }
        20% { transform: translateX(1px) rotate(8deg) }
        24% { transform: translateX(0px) rotate(0deg) }
        28% { transform: translateX(-1px) rotate(-2deg) }
        32% { transform: translateX(0px) rotate(0deg) }
        36% { transform: translateX(1px) rotate(8deg) }
        40% { transform: translateX(0px) rotate(0deg) }
    }
</style>
